export const LOCAL_STORAGE_KEYS = {
  API: {
    SELECTED_SERVER: "api.SelectedServer",
    SERVERS: "api.Servers"
  },
  PREFERENCES: {
    DIR: "preferences.Dir",
    LANG: "preferences.Lang"
  },
  AUTH: {
    ACCESS_TOKEN: "auth.AccessToken",
    REFRESH_TOKEN: "auth.RefreshToken"
  },
  USER: {
    INFO: "user.Info"
  }
}
